import React from 'react'
import { translate } from 'react-i18next'
import { Col, Row } from 'antd';
import { IconHelper } from '../../helpers'

const ContactHeader = ({ t }) => {
    const { IconArrowTel } = IconHelper
    return (
        <>
            <Row className="section-contact-header">
                <Col span={24}>
                    <section className="contact-header">
                        <p className="contact-text">
                            {t("menu_contact_page")}
                        </p>
                    </section>
                </Col>
                <Col span={24} className="col-contact contact-sub-header">
                    <Row justify="center">
                        <div id="contact-sub-header">
                            <span>{t('support_text.tab_1_text_4')}</span>
                        </div>
                    </Row>
                    <h1><IconArrowTel style={{ width: '22px' }} />&nbsp;02-700-8011</h1>
                    <span>{t('support_text.tab_1_text_5')}</span>
                </Col>
            </Row>
        </>
    )
}

export default translate()(ContactHeader)
